import { isElementNode } from 'anodum';

const isAligned = (element) => {
  if (!isElementNode(element)) return false;
  const { textAlign } = element.style;
  return ['right', 'center', 'left'].includes(textAlign);
};

export default isAligned;
